<template>
  <b-container fluid>
    <slot name="header"></slot>
    <br/>
    <!-- User Interface controls -->
    <b-row v-if="!simple">
      <b-col>
        <b-form-group horizontalclass="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Cerca..."/>
            <b-input-group-button>
              <b-btn :disabled="!filter" @click="filter = ''">Reset</b-btn>
            </b-input-group-button>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col>
        <slot name="filters"></slot>
      </b-col>
      <b-col>
        <b-form-group horizontal label="Ordine" class="mb-0">
          <b-input-group>
            <b-form-select v-model="sortBy" :options="sortOptions">
              <option slot="first" :value="null">-- Predefinito --</option>
            </b-form-select>
            <b-input-group-button>
              <b-form-select :disabled="!sortBy" v-model="sortDesc">
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group-button>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Main table element -->
    <b-table
      show-empty
      striped hover
      stacked="md"
      :small="small"
      :fixed="fixed"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @filtered="onFiltered"
      v-on:row-clicked="onRowClicked">

      <template slot="radio_id" slot-scope="row">
        <b-form-radio v-model="row.item.checked"/>
        {{ }}
      </template>

      <template slot="checkbox_id" slot-scope="row">
        <b-form-checkbox v-model="row.item.checked"/>
        {{ }}
      </template>
    </b-table>

    <b-row v-if="!simple">
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0"/>
      </b-col>
      <b-col md="3" offset-md="3" class="my-1">
        <b-form-group horizontal  class="mb-0">
          <b-form-select :options="pageOptions" v-model="currentPerPage">
            <option slot="first" :value="null" disabled>-- Num. per pagina --</option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <slot name="footer"></slot>
  </b-container>
</template>

<script>
  export default {
    props: {
      items: {
        type: Array,
        required: true,
      },
      fields: {
        type: Array,
        required: true,
      },
      simple: {
        type: Boolean,
        required: false,
        default: false,
      },
      small: {
        type: Boolean,
        required: false,
        default: false,
      },
      fixed: {
        type: Boolean,
        required: false,
        default: false,
      },
      opts: {
        type: Object,
        required: false,
      },
      onRowClicked: {
        type: Function,
        required: false,
      }
    },
    i18n: {
      messages: {
        it: {
          sortby: 'Ordina per',
          error: 'In errore',
          offline: 'Offline',
          active: 'Attivo',
          false: 'Falso',
          true: 'Vero'
        },
        en: {
          sortby: 'Sort by',
          error: 'In error',
          offline: 'Offline',
          active: 'Active',
          false: 'False',
          true: 'True'
        }
      }
    },
    mounted() {
      this.totalRows = this.items.length;
    },
    data: () => ({
      totalRows: 0,
      currentPage: 1,
      currentPerPage: 10,
      pageOptions: [5, 10, 15, 25, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {title: '', content: ''},
    }),
    computed: {
      perPage() {
        return this.simple ? this.items.length : this.currentPerPage;
      },
      sortOptions() {
        return this.fields
          .filter(f => f.sortable)
          .map(f => ({text: f.label, value: f.key}));
      },
    },

    mounted() {
      if (this.opts) {
        this.currentPerPage = this.opts.currentPerPage;
      }
    },

    methods: {
      filterSentinels(sentinel) {
        const filterMatch = new RegExp(this.filter.query, 'i');

        if (this.filter.query) {
          let match = filterMatch.test(sentinel.agent_serial) ||
            filterMatch.test(sentinel.agent_model) ||
            filterMatch.test(sentinel.agent_version) ||
            filterMatch.test(sentinel.customer.common_name) ||
            filterMatch.test(sentinel.user.first_name) ||
            filterMatch.test(sentinel.user.last_name)

          if (!match) return false
        }

        if (this.filter.errors !== '' && sentinel.has_error !== this.filter.errors) {
          return false;
        }

        if (this.filter.status !== '' && sentinel.status !== this.filter.status) {
          return false;
        }

        return true;
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/common/DataTable.vue